import React from 'react';
import FlowRendererField from 'conversie-flow-bundle/assets/js/components/flow/renderers/FlowRendererField';

/* Conversion Fields */
import ConversionFieldChoiceVwpfs from '../fields/ConversionFieldChoiceVwpfs';
import ConversionFieldMoney from '../fields/ConversionFieldMoney';

export default function ConversionComponentFinanceCalculator({ component, path, id, ...passProps }) {

    return (
        <>
            <FlowRendererField
                component={component}
                fields={component?.fields}
                path={`${path}.fields`}
                id={`${id}.fields`}
                {...passProps}
                renderField={(field, props) => {

                    if (field.type === 'choice-radio') {
                        return (
                            <div className="col-12">
                                <div className="row gutters-2 align-items-center">
                                    <div className="col-6">
                                        <p className="text--sm text-base font-weight-medium">
                                            {field?.label}
                                        </p>
                                    </div>
                                    <ConversionFieldChoiceVwpfs
                                        {...props}
                                        field={{
                                            ...field,
                                            label: null,
                                        }}
                                        ariaLabel={field?.label}
                                        colClassName="col-6"
                                        customControlClassName="custom-control--expanded"
                                        inputType="radio"
                                    />
                                </div>
                            </div>

                        );
                    }

                    if (field.type === 'money') {
                        return (
                            <div className={props?.colClassName}>
                                <div className="row gutters-2 align-items-center">
                                    <div className="col-6">
                                        <label htmlFor={props.id} className="form-label">
                                            {field?.label}
                                        </label>
                                    </div>
                                    <ConversionFieldMoney
                                        {...props}
                                        field={{
                                            ...field,
                                            label: null,
                                        }}
                                        colClassName="col-6"
                                        inputType="number"
                                    />
                                </div>
                            </div>

                        );
                    }
                }}
            />
            <div className="col-12 mt-2">
                <div className="row gutters-1">
                    <div className="col-6">
                        <p className="text--16 text-base font-weight-medium">Aankoopbedrag</p>
                    </div>
                    <div className="col-6">
                        <p className="text--16 h6">{`€ ${parseInt(component.metadata.total_price).toLocaleString('nl-NL')}`}</p>
                    </div>
                    <div className="col-6">
                        <p className="text--16 text-base font-weight-medium">Leenbedrag</p>
                    </div>
                    <div className="col-6">
                        <p className="text--16 h6">{`€ ${parseInt(component.metadata.vehicle_price).toLocaleString('nl-NL')}`}</p>
                    </div>
                    <div className="col-6">
                        <p className="text--16 text-base font-weight-medium">Totaal</p>
                    </div>
                    <div className="col-6">
                        <span className="h6">{`€ ${parseInt(component.metadata.price_per_month).toLocaleString('nl-NL')}`} <span className="text--16 text-muted--40 font-weight-normal">/mnd</span></span>
                    </div>
                </div>
            </div>
        </>
    );
}
